import {
  calculateBonusPoints,
  calculateProjectedScore,
  calculateQsoPoints,
  calculateScoreBreakdown,
  DEFAULT_STATION_SETTINGS,
  formatExchange,
  normalizeStationSettings,
  validateClass,
  validateLocation,
  ARRL_CLASS_TOOLTIP,
  ARRL_CLASS_PLACEHOLDER,
  ARRL_VALID_SECTIONS
} from '../fieldDayRules';
import {
  AZQP_FORM,
  AZQP_PROGRESS_GROUPS,
  AZQP_VALID_BANDS,
  AZQP_VALID_MODES,
  DEFAULT_AZQP_STATION_SETTINGS,
  calculateAzqpProjectedScore,
  calculateAzqpQsoPoints,
  calculateAzqpScoreBreakdown,
  formatAzqpExchange,
  getAzqpExchangeName,
  isAzqpDuplicateContact,
  normalizeAzqpSettings,
  validateAzqpExchange,
  validateRst
} from '../azqpRules';

const fieldDay = {
  slug: 'field-day',
  normalizeStationSettings,
  DEFAULT_STATION_SETTINGS,
  validateClass,
  validateLocation,
  validateRst: () => true,
  validateExchange: validateLocation,
  calculateQsoPoints,
  calculateScoreBreakdown,
  calculateProjectedScore: (contacts, settings) => {
    const qsoPoints = calculateQsoPoints(contacts);
    return calculateProjectedScore(qsoPoints, settings);
  },
  calculateBonusPoints,
  formatExchange,
  isDuplicateContact: (contacts, callsign, frequency, mode) => (
    contacts.some((contact) => contact.deleted !== 'Y'
      && contact.callsign?.toUpperCase() === String(callsign || '').toUpperCase()
      && contact.frequency === frequency
      && contact.mode === mode)
  ),
  progressGroups: null,
  progressTitle: 'ARRL Sections Progress',
  form: {
    rstField: 'classSent',
    rstLabel: 'Class',
    rstPlaceholder: ARRL_CLASS_PLACEHOLDER,
    rstTooltip: ARRL_CLASS_TOOLTIP,
    locationLabel: 'Location',
    locationPlaceholder: 'e.g., AZ, DX',
    locationTooltip: 'ARRL/RAC section, MX, or DX',
    showCallSignArea: true
  },
  validBands: null,
  validModes: null,
  getExchangeName: (code) => code,
  validExchangeList: ARRL_VALID_SECTIONS,
  hasStationConfig: (settings) => Boolean(settings?.entryClass),
  scoreDetailLine: (projected, qsoPoints) => (
    `${qsoPoints} QSO × ${projected.powerMultiplier} + ${projected.bonusPoints} bonus`
  ),
  projectedScoreLabel: 'Projected Score'
};

const azqp = {
  slug: 'azqp',
  normalizeStationSettings: normalizeAzqpSettings,
  DEFAULT_STATION_SETTINGS: DEFAULT_AZQP_STATION_SETTINGS,
  validateClass: validateRst,
  validateLocation: validateAzqpExchange,
  validateRst,
  validateExchange: validateAzqpExchange,
  calculateQsoPoints: calculateAzqpQsoPoints,
  calculateScoreBreakdown: calculateAzqpScoreBreakdown,
  calculateProjectedScore: (contacts, settings) => ({
    ...calculateAzqpProjectedScore(contacts, settings),
    exchange: formatAzqpExchange(settings)
  }),
  calculateBonusPoints: () => ({ total: 0, breakdown: [] }),
  formatExchange: formatAzqpExchange,
  isDuplicateContact: isAzqpDuplicateContact,
  progressGroups: AZQP_PROGRESS_GROUPS,
  progressTitle: 'AZQP Exchange Progress',
  form: AZQP_FORM,
  validBands: AZQP_VALID_BANDS,
  validModes: AZQP_VALID_MODES,
  getExchangeName: getAzqpExchangeName,
  validExchangeList: null,
  hasStationConfig: (settings) => Boolean(settings?.callsign && settings?.sentLocation),
  scoreDetailLine: (projected) => (
    `${projected.qsoPoints} QSO × ${projected.multipliers.total} mult + ${projected.bonusPoints} bonus`
  ),
  projectedScoreLabel: 'Projected AZQP Score'
};

const RULES_BY_CONTEST = {
  'field-day': fieldDay,
  azqp
};

export function getRulesModule(ruleset) {
  return RULES_BY_CONTEST[ruleset] || fieldDay;
}

export function getRulesModuleForContest(contestSlug) {
  if (contestSlug === 'azqp') {
    return azqp;
  }
  return fieldDay;
}
